import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { tableHeadersLine } from '../dataConnectMultiCluster/DataConnectMultiClusterTableHeaders';

export function DataConnectMultiPoolTableHeaders() {
  return <>
    <tbody>
      <tr>
        <th  colSpan={2} className={tableHeadersLine} style={{paddingLeft:12}}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-name-column-header'} >
            {Messages.dataConnectSiteSettingsPoolColumnName()}
          </span>
        </th>
        <th className={tableHeadersLine}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-status-column-header'}>
            {Messages.dataConnectSiteSettingsPoolStatusColumnName()}
          </span>
        </th>
        <th className={tableHeadersLine}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-alerts-column-header'}>
            {Messages.dataConnectSiteSettingsPoolAlertsColumnName()}
          </span>
        </th>
        <th className={tableHeadersLine}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-cluster-column-header'}>
            {Messages.dataConnectSiteSettingsPoolClusterColumnName()}
          </span>
        </th>
        <th className={tableHeadersLine}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-domain-column-header'}>
            {Messages.dataConnectSiteSettingsPoolDomainColumnName()}
          </span>
        </th>
        <th className={tableHeadersLine}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-token-column-header'}>
            {Messages.dataConnectSiteSettingsPoolTokenColumnName()}
          </span>
        </th>
        <th className={tableHeadersLine}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-image-build-column-header'}>
            {Messages.dataConnectSiteSettingsPoolImageBuildColumnName()}
          </span>
        </th>
        <th className={tableHeadersLine}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-image-deploy-column-header'}>
            {Messages.dataConnectSiteSettingsPoolDeployColumnName()}
          </span>
        </th>
        <th className={tableHeadersLine} data-tb-test-id={'pool-actions-column-header'}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-actions-column-header'}>
            {Messages.dataConnectSiteSettingsPoolActionsColumnName()}
          </span>
        </th>
      </tr>
    </tbody>
  </>;
}

export const DataConnectTooltipClass = style({
  height: CommonStyles.Sizes.ExtraSmallIconSize,
  marginLeft: TabStyles.Spacing.SmallSpace,
  verticalAlign: 'text-top',
  outlineStyle: 'none'
});
